import * as React from "react";
import { DateInput as CoreDateInput } from "./dateInput";
import { getJavaDate, stringInputFormatMonth, stringInputParseMonthDate } from "./baseFormating";
import { parseISO } from "date-fns";
import { csLocalizer } from "./csLocalizer";

export type IMonthInputProps = Omit<
    React.PureComponent<typeof CoreDateInput>,
    | "value"
    | "onChange"
    | "onBlur"
    | "onFocus"
    | "formatDate"
    | "parseDate"
    | "canClearSelection"
    | "clearButtonText"
    | "invalidDateMessage"
    | "locale"
    | "localeUtils"
    | "modifiers"
    | "onError"
    | "outOfRangeMessage"
    | "popoverProps"
    | "reverseMonthAndYearMenus"
    | "shortcuts"
    | "timePickerProps"
    | "timePrecision"
    | "todayButtonText"
    | "showActionsBar"
    | "closeOnSelection"
    | "dayPickerProps"
    | "highlightCurrentDay"
    | "initialMonth"
    | "maxDate"
    | "minDate"
    | "required"
    | "rightElement"
> & {
    value: string;
    onChange?: (newValue?: string) => void;
    onBlur?: (newValue?: string) => void;
    onFocus?: (newValue?: string) => void;
    disabled?: boolean;
    className?: string;
    /**
     * Pokud bude true, bude se dávat při vybrání měsíce poslední den daného měsíce, standardně je toto vypnuto
     */
    endOfMonth?: boolean;
};

/**
 * Komponenta pro editaci měsíce.
 */
export class MonthInput extends React.PureComponent<IMonthInputProps> {
    render() {
        const { value, onChange, onBlur, onFocus, disabled, inputProps, endOfMonth, ...other } = this.props as any;

        const realValue: Date | null = value === "" || value === null || value === undefined ? null : parseISO(value);
        return (
            <CoreDateInput
                localeUtils={csLocalizer}
                locale={"cs"}
                {...other}
                onChange={selectedDate => {
                    if (selectedDate instanceof Date && isNaN(selectedDate as any)) {
                        // ignore change - leave last valid date
                    } else if (selectedDate === null) {
                        onChange?.("");
                    } else {
                        let useDate: Date;
                        if (endOfMonth) {
                            useDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0);
                        } else {
                            useDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
                        }
                        // @ts-ignore
                        onChange?.(getJavaDate(useDate));
                    }
                }}
                onBlur={selectedDate => {
                    // @ts-ignore
                    onBlur?.(getJavaDate(selectedDate));
                }}
                onFocus={selectedDate => {
                    // @ts-ignore
                    onFocus?.(getJavaDate(selectedDate));
                }}
                value={realValue}
                // @ts-ignore
                formatDate={stringInputFormatMonth}
                parseDate={v => stringInputParseMonthDate(v, !!endOfMonth)}
                disabled={disabled}
                inputProps={{ ...inputProps, disabled }}
            />
        );
    }
}
